<template>
  <section>
    <div class="text-md-center">
        <div class="file-actions">
          <div>
            <v-tooltip top>
              <v-btn slot="activator" color="default" v-on:click.prevent="requestDownload">
                <v-icon>cloud_download</v-icon>
                &ensp;
                <span>{{ resumen }}</span>
              </v-btn>
              <span>{{ formato }}</span>
            </v-tooltip>
          </div>
        </div>
    </div>
  </section>
</template>
<script>
import mime from 'mime-types';
import axios from 'axios';
export default {
  props: {
    msg_id: {
      type: String,
      default: null
    },
    caso: {
      type: Number,
      default: null
    },
    file: {
      type: String,
      default: null
    },
    mime: {
      type: String,
      default: null
    },
    extras: {
      type: Object,
      default: function () { return {}; }
    }
  },
  created () {

  },
  beforeDestroy () {},
  mounted () {},
  data () {
    return {
      nombre: 'Archivo',
      blob: null,
      original: null
    };
  },
  computed: {
    resumen () {
      if (this.extras && this.extras.filename) {
        let nombre = this.extras.filename || 'documento sin titulo...';
        if (nombre.length > 30) {
          return nombre.substr(0, 30) + '...';
        } else return nombre;
      } else {
        return 'Descargar';
      }
    },
    formato () {
      // if (this.extras) {
      //   let nombre = this.extras.filename || 'Descargar archivo';
      //   return nombre;
      // } else {
      //   return 'Descargar Documento';
      // }
      return this.extras && this.extras.filename ? this.extras.filename : 'Descargar archivo';
    }
  },
  watch: {},
  methods: {
    async downloadFile (url, type) {
      if (url.indexOf('data:') === -1) {
        let _urlTarget = `${url}`;
        if (url.indexOf('http') === -1) {
          _urlTarget = `${process.env.API_URL}${url}`;
        }
        try {
          return new Promise((resolve, reject) => {
            axios({
              url: _urlTarget,
              method: 'GET',
              responseType: 'arraybuffer',
              headers: {
                Authorization: `${this.$authToken} ${this.$storage.get('token')}`
              }
            }).then(response => {
              let file = new window.Blob([response.data], { type: type });
              this.blob = window.URL.createObjectURL(file);
              this.download(this.blob);
            })
            .catch(err => {
              // this.$message.error(err.message);
              console.log(err.message);
              this.blob = this.file;
            });
          });
        } catch (err) {
          // this.$message.error(err.message);
          this.blob = this.file;
        }
      } else {
        this.blob = this.file;
      }
    },
    async downloadOriginal () {
      this.$loading.show('Preparando archivo...');
      try {
        let url = `system/mensajes/descargar/${this.caso}/${this.msg_id}`;
        return new Promise((resolve, reject) => {
          axios({
            url: `${process.env.API_URL}${url}`,
            method: 'GET',
            responseType: 'arraybuffer',
            headers: {
              Authorization: `${this.$authToken} ${this.$storage.get('token')}`
            }
          }).then(response => {
            this.$loading.hide();
            let _options = {};
            if (response.headers && response.headers.hasOwnProperty(`content-type`)) {
              _options.type = response.headers['content-type'];
              let extension = mime.extension(_options.type);
              if (extension) {
                this.nombre = `Archivo.${extension}`;
              }
            }
            let file = new window.Blob([response.data], _options);
            this.original = window.URL.createObjectURL(file);
            this.download(this.original);
            // this.$message.success(`El archivo original esta preparado para su Descarga!`, null, { timeout: 2000 });
          })
          .catch(err => {
            this.$loading.hide();
            // this.$message.error(err.message);
            console.log(err.message);
            this.original = this.blob;
            // this.$message.success(`El archivo original esta preparado para su Descarga!`, null, { timeout: 2000 });
          });
        });
      } catch (err) {
        this.$loading.hide();
        this.$message.error(err.message);
        this.original = this.blob;
        // this.$message.success(`El archivo original esta preparado para su Descarga!`, null, { timeout: 2000 });
      }
    },
    async requestDownload () {
      if (!this.blob && this.file && this.file !== '') {
        await this.downloadFile(this.file, this.mime);
      }
      if (!this.original) {
        await this.downloadOriginal();
      }

      this.download(this.original);
    },
    download (archivo) {
      const link = document.createElement('a');
      link.href = archivo;
      link.setAttribute('target', '_blank');
      link.setAttribute('download', `${this.nombre}`);
      document.body.appendChild(link);
      link.click();
    }
  },
  updated () {},
  components: { axios }
};
</script>
<style src="./file.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/common/plugins/file/File.vue